// @ts-expect-error TS7016 -- MIGRATION: not approved, fix when encountered
import { sortAllergiesList } from 'ui_kit_qmd/build/utils/common'
import { convertStatusToCorrectUiFormat, parseUserDateTime, severitiesData } from '../../../utils/common'
import {
  DAYS_ONLY_TEXT,
  DAY_TEXT,
  FOR_TEXT,
  INTAKE_FORM_PREFERRED_PHARMACY_QUESTION,
  visitsStatuses,
} from '../../../utils/constants'
import { getVisitMethodOptionFromVisitMethod } from '../../new-visit/components/visit-information/VisitMethods'

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export const generateAllergiesDataSkeleton = (allergies) => {
  if (!allergies?.length) {
    return []
  }
  // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
  return sortAllergiesList(allergies)?.map((allergy, index) => {
    const allergyAuthor = allergy?.Author
    const { Prefix, Suffix, LastName, FirstName, UserType } = allergyAuthor
    return {
      content: [
        // @ts-expect-error TS7053 -- MIGRATION: not approved, fix when encountered
        { name: 'Severity', value: severitiesData[allergy.Severity].value },
        {
          name: 'Reported by',
          value: UserType === 'patient' ? 'Self-reported' : `${Prefix || ''} ${FirstName} ${LastName} ${Suffix || ''}`,
        },
      ],
      isAllergy: true,
      allergyName: allergy.Name,
      propertyTitle: index === 0 ? 'Allergies' : '',
    }
  })
}

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
const generatePastVisitNotesDataSkeleton = (pastVisitsNotes, userTimeZone) => {
  if (!pastVisitsNotes?.length) {
    return []
  }
  // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
  return pastVisitsNotes.map((pastVisitsNote) => {
    const { IsAddendum, DateTime, Author, Message } = pastVisitsNote || {}
    const { FirstName, LastName, Suffix, Prefix } = Author || {}
    return {
      subtitleLabel: IsAddendum ? 'Visit note addendum' : 'Visit note',
      writtenBy: FirstName ? `${Prefix || ''} ${FirstName} ${LastName} ${Suffix || ''}` : '',
      savedOn: parseUserDateTime(DateTime, userTimeZone, true),
      noteMsg: Message ?? '--',
      isWithoutWrittenBy: !IsAddendum,
    }
  })
}
// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
const generateIcd10CodesDataSkeleton = (icd10Codes) => {
  if (!icd10Codes?.length) {
    return []
  }
  // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
  return icd10Codes.map((icd10Code) => {
    const { Code, Description } = icd10Code || {}
    return {
      code: Code,
      codeMsg: Description,
    }
  })
}
// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
const generatePatientInstructionsDataSkeleton = (patientInstructions, userTimeZone) => {
  if (!patientInstructions?.length) {
    return []
  }
  // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
  return patientInstructions.map((patientInstruction) => {
    const { Message, IsAddendum, DateTime, Author } = patientInstruction || {}
    const { FirstName, LastName, Suffix, Prefix } = Author || {}

    return {
      subtitleLabel: IsAddendum ? 'Patient instruction addendum' : 'Patient instructions',
      writtenBy: FirstName ? `${Prefix || ''} ${FirstName} ${LastName} ${Suffix || ''}` : '',
      savedOn: parseUserDateTime(DateTime, userTimeZone, true),
      patientInstructionMsg: Message ?? '--',
      isWithoutWrittenBy: !IsAddendum,
    }
  })
}

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export const generatePastVisitsDataSkeleton = (pastVisits, userTimeZone) => {
  if (!pastVisits?.length) {
    return []
  }
  // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
  return pastVisits.map((pastVisit) => {
    const {
      ServiceTypeName,
      VisitTypeName,
      Method,
      Status,
      VisitDateTime,
      Provider,
      Notes,
      PatientInstructions,
      IcdCodes,
    } = pastVisit || {}
    const { FirstName, LastName, Suffix, Prefix } = Provider || {}
    return {
      content: {
        pastVisitMainProperties: [
          { name: 'Visit type', value: `${ServiceTypeName ?? ''} - ${VisitTypeName ?? ''}` },
          { name: 'Visit method', value: getVisitMethodOptionFromVisitMethod(Method) },
          { name: 'Visit status', value: visitsStatuses[Status] },
          { name: 'Provider', value: `${Prefix || ''} ${FirstName} ${LastName} ${Suffix || ''}` },
        ],
        pastVisitProperties: [...generatePastVisitNotesDataSkeleton(Notes, userTimeZone)],
        icd10Codes: [...generateIcd10CodesDataSkeleton(IcdCodes)],
        patientInstructions: [...generatePatientInstructionsDataSkeleton(PatientInstructions, userTimeZone)],
      },
      title: `Visit: ${parseUserDateTime(VisitDateTime, userTimeZone, true)}`,
    }
  })
}

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
const generateQuestionsDataSkeleton = (questions) => {
  if (!questions?.length) {
    return []
  }
  // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
  return questions.map((question, index) => {
    const questionNumber = index + 1
    switch (question.Type) {
      case 'statement': {
        return {
          question: `Q${questionNumber}. ${question.Question}`,
          answer: 'N/A',
        }
      }
      case 'textbox': {
        return {
          question: `Q${questionNumber}. ${question.Question}`,
          answer: question?.Text ?? '--',
        }
      }
      case 'email': {
        return {
          question: `Q${questionNumber}. ${question.Question}`,
          answer: question?.Email ?? '--',
        }
      }
      case 'condition': {
        return {
          question: `Q${questionNumber}. ${question.Question}`,
          answer:
            question?.Option ? `${question.Option} ${question?.InputValue ? ` - ${question?.InputValue}` : ''}` : '--',
        }
      }
      case 'bodymeasurement': {
        return {
          question: `Q${questionNumber}. How tall are you and what is your current weight?`,
          answer:
            question?.HeightInches ?
              // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
              `${parseInt(question.HeightInches / 12, 10)}ft and ${question.HeightInches % 12}in - ${
                question?.WeightPounds
              }lbs`
            : '--',
        }
      }
      case 'pharmacyselection': {
        return {
          question: `Q${questionNumber}. ${INTAKE_FORM_PREFERRED_PHARMACY_QUESTION}?`,
          answer: question?.PharmacyId ? `${question.Name} - ${question.Address}` : '--',
        }
      }
      case 'file': {
        return {
          question: `Q${questionNumber}. ${question.Question}`,
          // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
          answer: question?.Files?.length > 0 ? question.Files.map((t) => t.Name).join('; ') : '--',
        }
      }
      case 'option': {
        return {
          question: `Q${questionNumber}. ${question.Question}`,
          answer:
            question?.Options.length ?
              // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
              question?.Options.map((name, optionIndex) => (optionIndex === 0 ? name : `; ${name}`))
            : '--',
        }
      }
      default: {
        break
      }
    }
  })
}

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export const generateIntakeFormsDataSkeleton = (intakeForms, userTimeZone) => {
  if (!intakeForms?.length) {
    return []
  }
  // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
  return intakeForms.map((intakeForm) => {
    const { Name, CompleteDateTime, VisitTypeName, Questions } = intakeForm || {}

    return {
      content: {
        intakeFormMainProperties: [
          {
            name: 'Completed on',
            value: CompleteDateTime ? parseUserDateTime(CompleteDateTime, userTimeZone, false) : '--',
          },
          { name: 'Visit type', value: VisitTypeName },
        ],
        questions: [...generateQuestionsDataSkeleton(Questions)],
      },
      title: Name,
    }
  })
}

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export const generatePrescriptionsDataSkeleton = (prescriptions, userTimeZone) => {
  if (!prescriptions?.length) {
    return []
  }
  // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
  return prescriptions.map((prescription) => {
    const {
      DispenseAmount,
      Doctor,
      Quantity,
      Dosage,
      Directions,
      Frequency,
      Refills,
      Pharmacy,
      CreatedAt,
      DrugName,
      Duration,
      Note,
    } = prescription || {}

    const prescriber = Doctor || {}
    const { Name, NcpdpId, Phone, Address } = Pharmacy || {}
    const Street =
      Address?.StreetAddress1 ?
        `${Address.StreetAddress1}${Address.StreetAddress2 ? ', ' : ''}${Address.StreetAddress2 || ''}`
      : '--'
    const { FirstName, LastName, Designation } = prescriber || {}
    const quantityAndDosage = Quantity === null ? '--' : `${Quantity} ${Dosage || ''}`
    const fullPrescriberName =
      FirstName && LastName ? `${FirstName} ${LastName}${Designation ? ', ' : ''} ${Designation}` : '--'

    const createdAtDate = CreatedAt ? parseUserDateTime(CreatedAt, userTimeZone, false) : '--'
    const frequency =
      Frequency ? `${Frequency} ${FOR_TEXT} ${Duration} ${Duration === 1 ? DAY_TEXT : DAYS_ONLY_TEXT}` : '--'
    return {
      content: [
        { name: 'Status', value: convertStatusToCorrectUiFormat(prescription.Status) },
        { name: 'Prescriber', value: fullPrescriberName },
        { name: 'Dispense amount', value: DispenseAmount },
        { name: 'Quantity (and dosage)', value: quantityAndDosage },
        { name: 'Directions', value: Directions ?? '--' },
        { name: 'Frequency', value: frequency },
        { name: 'Refills', value: Refills ?? '--' },
        { name: 'Pharmacy', value: Name ?? '--' },
        { name: 'NCPDP ID', value: NcpdpId ?? '--' },
        { name: 'Phone', value: Phone ?? '--' },
        { name: 'Street', value: Street },
        { name: 'City', value: Address?.City ?? '--' },
        { name: 'State', value: Address?.StateCode ?? '--' },
        { name: 'Zip', value: Address?.Zip ?? '--' },
        { name: 'Created', value: createdAtDate },
        { name: 'Note', value: Note ?? '--' },
      ],

      propertyTitle: `Medication name: ${DrugName}`,
    }
  })
}
